import system from './system.js'
import organize from './organize.js'
import trend from './trend.js'
import product from './product.js'
import project from './project.js'
import mall from './mall.js'
import job from './job.js'
export default {
  system, organize, trend, product, project, mall,job
}
